<template>
  <div class="telefone-internacional">
    <label v-if="label">{{ label }}</label>
    <vue-tel-input
      :id="name ?? 'telefone'"
      v-model="phoneValue"
      default-country="BR"
      :preferred-countries="preferredCountries"
      :valid-countries="validCountries"
      :disabled="disabled"
      :placeholder="placeholder"
      :dropdown-options="dropdownOptions"
      :input-options="inputOptions"
      @validate="onValidate"
      @country-changed="onCountryChanged"
      @input="onInput"
      ref="telInput"
    ></vue-tel-input>
    <span v-if="error && phoneValue.length > 4" class="erro">{{ error }}</span>
  </div>
</template>

<script>
// Importação correta para Vue 3
import { VueTelInput } from 'vue-tel-input';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export default {
  name: 'TelefoneInternacional',
  components: {
    VueTelInput
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Telefone'
    },
    placeholder: {
      type: String,
      default: 'Digite o telefone'
    },
    permitirApenascelular:{
      type: Boolean,
      default: false
    },
    opcional:{
      type: Boolean,
      default: false
    },
    preferredCountries: {
      type: Array,
      default: () => ['BR', 'US', 'PT', 'ES']
    },
    validCountries: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      phoneValue: this.modelValue != '+55 ' && this.modelValue != '+55' ? this.modelValue : '',
      isValid: false,
      error: '',
      selectedCountry: null,
      currentDialCode: '',
      isChangingCountry: false, // Flag para controlar mudanças de país
      isInitialized: false, // Flag para controlar se o componente já foi inicializado
      isLegacyValue: false, // Flag para identificar valores legados sem DDI
      initialLegacyValue: null, // Para guardar o valor legado inicial
      dropdownOptions: {
        showDialCodeInSelection: false,
        showDialCodeInDropdown: true,    
        showDialCodeInList: true,     
        showFlags: true,
        showSearchBox: true,
        searchPlaceholder: 'Buscar país...'
      },
      inputOptions: {
        showDialCode: true,
        autoFormat: true,
        mode: 'international',
        placeholder: this.placeholder
      }
    };
  },
  mounted() {

    this.initialLegacyValue = this.modelValue;
    if (this.initialLegacyValue && !this.initialLegacyValue.match(/^\+\d+/)) {
      this.isLegacyValue = true;
    }
    
        setTimeout(() => {
      this.initializeComponent();
    }, 100);
  },
  watch: {
    modelValue(newVal) {
      this.phoneValue = this.limparNumero(newVal);
    },
    phoneValue(newVal, oldVal) {
      // Na primeira vez que o valor muda após a inicialização, não fazemos verificações
      // Isso permite que valores legados sem DDI sejam mantidos durante a inicialização
      if (!this.isInitialized) {
        this.isInitialized = true;
        this.$emit('update:modelValue', newVal);
        return;
      }
      
      // Se estamos no meio de uma mudança de país, permitimos qualquer valor
      if (this.isChangingCountry) {
        this.$emit('update:modelValue', newVal);
        return;
      }
      
      // Se o valor for vazio ou undefined, emitimos normalmente
      if (!newVal) {
        this.$emit('update:modelValue', newVal);
        return;
      }
      
      const dialCode = `+${this.currentDialCode}`;
      
      // Verifica se o valor atual tem DDI
      const hasDDI = newVal.match(/^\+\d+/) !== null;
      
      // Se não tem DDI, marcamos como valor legado e permitimos, mas sinalizamos como inválido
      if (!hasDDI && this.isInitialized) {
        this.isLegacyValue = true;
        this.isValid = false;
        this.$emit('update:modelValue', this.limparNumero(newVal));
        this.$emit('validate', {
          name: this.name,
          valid: false,
          country: this.selectedCountry,
          number: this.limparNumero(newVal)
        });
        return;
      }
      
      // Se o valor tem DDI, não é mais um valor legado
      this.isLegacyValue = false;
      
      // Verificações específicas para valores com DDI:
      
      // Verifica se estamos em um caso de mudança de país ou remoção inválida de DDI
      const isCorrectDDI = newVal.startsWith(dialCode);
      const isPartialDDI = dialCode.startsWith(newVal);
      
      // Se o valor tem um DDI completo mas não é o correto, 
      // provavelmente é uma mudança de país - permitimos
      if (hasDDI && !isCorrectDDI && !isPartialDDI) {
        this.$emit('update:modelValue', newVal);
        return;
      }
      
      // Se o valor atual é um DDI parcial do DDI correto (ex: "+5" para "+55")
      // restauramos o DDI completo
      
      if (isPartialDDI || (!isCorrectDDI && oldVal && oldVal.startsWith(dialCode))) {
        // Restaura o DDI correto
        const restOfNumber = oldVal.substring(dialCode.length);
        const correctedValue = dialCode + restOfNumber;
        
        // Atualizamos o valor com o DDI correto
        this.phoneValue = this.limparNumero(correctedValue);
        this.$emit('update:modelValue', correctedValue);
        
        // Coloca o cursor após o DDI na próxima atualização do DOM
        this.$nextTick(() => {
          const input = this.$el.querySelector('input');
          if (input) {
            input.setSelectionRange(dialCode.length, dialCode.length);
          }
        });
        
        return;
      }


      if(this.permitirApenascelular){
        const phone = parsePhoneNumberFromString(this.phoneValue);
        

        if(phone && phone.getType() == 'MOBILE'){
          this.error = '';
          this.isValid = true;

          this.$emit('validate', {
            name: this.name,
            valid: true,
            country: this.selectedCountry,
            number: this.phoneValue
          });

        }else{
          this.error = 'Número de celular inválido';
          this.isValid = false;

          this.$emit('validate', {
            name: this.name,
            valid: false,
            country: this.selectedCountry,
            number: this.phoneValue
          });

        }
        return;
      }

      this.$emit('update:modelValue', this.limparNumero(newVal));
    }
  },
  methods: {
    limparNumero(newVal){
      if(newVal){
        var comMais = newVal.startsWith('+');
        let numeros = newVal.replace(/[^\d\s]/g, '');
        var telefoneFormatado = comMais ? `+${numeros}` : '+' + this.currentDialCode + ' ' + numeros;
        if(telefoneFormatado){
          return telefoneFormatado
        }else{
          return '+' + this.currentDialCode + ' ';
        }
      }else{
        return '';
      }
    },
    initializeComponent() {
      // Obter o código de discagem inicial
      if (this.$refs.telInput && this.$refs.telInput.activeCountry) {
        this.currentDialCode = this.$refs.telInput.activeCountry.dialCode;
      }
      
      // Se o valor inicial não começa com nenhum DDI, usamos ele diretamente sem modificar
      // Isso preserva os dados legados que não possuem DDI
      const initialValue = this.initialLegacyValue || '';
      const hasDDI = initialValue.match(/^\+\d+/);

      if (!hasDDI && initialValue) {
        // Manter o valor legado sem adicionar DDI
        this.phoneValue = '+55' + initialValue;
        this.isLegacyValue = true;
        
      }
      

        this.setupInputProtection();
      
    },
    
    setupInputProtection() {
      const input = this.$el.querySelector('input');
      if (!input) return;
      
      // Remove listeners existentes
      input.removeEventListener('keydown', this.handleKeydown);
      
      // Adiciona novos listeners
      input.addEventListener('keydown', this.handleKeydown);
    },
    
    handleKeydown(e) {
      const input = e.target;
      const dialCode = `+${this.currentDialCode}`;
      const value = input.value;
      const cursorPos = input.selectionStart;
      const cursorEnd = input.selectionEnd;

      
      // Não interfere se estamos em mudança de país
      if (this.isChangingCountry) return;
      
      // Não interferimos se o valor não começa com um DDI
      // Isso permite a edição de valores legados sem DDI
      if (!value.match(/^\+\d+/)) return;
      
      // Se o valor não começa com o DDI correto e é um Delete/Backspace
      // bloqueamos para evitar mais remoção
      if (!value.startsWith(dialCode) && (e.key === 'Backspace' || e.key === 'Delete')) {
        // Se o valor atual é um DDI parcial, bloqueamos
        if (dialCode.startsWith(value)) {
          e.preventDefault();
          // Restauramos o DDI completo
          this.$nextTick(() => {
            this.phoneValue = dialCode;
            input.setSelectionRange(dialCode.length, dialCode.length);
          });
          
          return;
        }
      }
      
      // Bloqueia deletar parte do DDI usando Delete
      if (e.key === 'Delete' && cursorPos < dialCode.length) {
        e.preventDefault();
        // Se a seleção inclui algo após o DDI, remove apenas essa parte
        if (cursorEnd > dialCode.length) {
          const textBeforeDDI = value.substring(0, dialCode.length);
          const textAfterSelection = value.substring(cursorEnd);
          
          this.$nextTick(() => {
            // Ajusta a seleção para começar após o DDI
            input.setSelectionRange(dialCode.length, cursorEnd);
            
            // Não usamos simulação de tecla aqui para evitar loops
            this.phoneValue = textBeforeDDI + textAfterSelection;
          });
        } else {
          // Apenas reposiciona o cursor após o DDI
          this.$nextTick(() => {
            input.setSelectionRange(dialCode.length, dialCode.length);
          });
        }
        
        return;
      }
      
      // Bloqueia deletar parte do DDI usando Backspace
      if (e.key === 'Backspace' && cursorPos <= dialCode.length) {
        e.preventDefault();
        
        // Se a seleção inclui algo após o DDI, remove apenas essa parte
        if (cursorEnd > dialCode.length) {
          const textBeforeDDI = value.substring(0, dialCode.length);
          const textAfterSelection = value.substring(cursorEnd);
          
          this.$nextTick(() => {
            this.phoneValue = textBeforeDDI + textAfterSelection;
            input.setSelectionRange(dialCode.length, dialCode.length);
          });
        } else {
          // Apenas reposiciona o cursor após o DDI
          this.$nextTick(() => {
            input.setSelectionRange(dialCode.length, dialCode.length);
          });
        }
        
        return;
      }
    },
    
    onValidate(validation) {
      
      // Se for um valor legado (sem DDI), marcamos como inválido
      if (this.isLegacyValue) {
        return;
      }
      
      // Processamento normal de validação para valores com DDI
      this.isValid = validation.valid;

      if (!validation.valid && this.phoneValue && this.phoneValue.length > 3) {
        this.error = 'Telefone inválido';
      } else {
        this.error = '';
      }

      if(this.permitirApenascelular){
        // eslint-disable-next-line no-debugger
        const phone = parsePhoneNumberFromString(this.phoneValue);

        if(phone && phone.getType() != 'MOBILE'){
          this.error = 'Número de celular inválido.';
        }else{
          this.error = '';
        }
      }

      this.$emit('validate', {
        name: this.name,
        ...validation
      });
    },
    
    onCountryChanged(country) {
      // Verificamos se o valor atual tem DDI ou não
      const hasDDI = this.phoneValue && this.phoneValue.match(/^\+\d+/);
      
      // Se não tem DDI, tratamos como um valor legado e não alteramos o valor
      if (!hasDDI) {
        this.selectedCountry = country;
        if (country && country.dialCode) {
          this.currentDialCode = country.dialCode;
        }
        
        // Marcamos como valor legado e inválido
        this.isLegacyValue = true;
        this.isValid = false;
        this.error = 'Telefone sem código internacional';
        
        this.$emit('country-changed', country);
        return;
      }
      
      // A partir daqui, valores com DDI
      
      // Ativa a flag para permitir mudanças de país
      this.isChangingCountry = true;
      
      this.selectedCountry = country;
      if (country && country.dialCode) {
        this.currentDialCode = country.dialCode;
      }
      
      this.$emit('country-changed', country);
      
      // Desativa a flag após um breve delay para permitir
      // que o vue-tel-input termine suas atualizações
      setTimeout(() => {
        this.isChangingCountry = false;
        
        // Reconfigura a proteção do input
        this.setupInputProtection();
      }, 200);
    },
    
    onInput() {
      // Se o valor não tem DDI, marcamos como valor legado
      if (this.phoneValue && !this.phoneValue.match(/^\+\d+/)) {
        this.isLegacyValue = true;
      } else if (this.phoneValue) {
        // Se tem DDI, não é um valor legado
        this.isLegacyValue = false;
      }
      
      // Emite o valor tal como recebido do componente
      this.$emit('update:modelValue', this.phoneValue);
    }
  }
};
</script>

<style scoped>
.telefone-internacional {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

label {
  margin-bottom: 7px;
  font-weight: 500;
}

.erro {
  color: red;
  font-size: 0.8rem;
  margin-top: 5px;
}

/* Estilo personalizado para o componente */
:deep(.vue-tel-input) {
  height: 41px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
}

:deep(.vue-tel-input:focus-within) {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

:deep(.vti__dropdown) {
  border-radius: 8px 0 0 8px;
  border-right: 1px solid #d0d5dd;
}

:deep(.vti__input) {
  background-color: white;
  border: none;
  padding: 8px;
  font-size: 1rem;
  border-radius: 0px 8px 8px 0px;
}
</style>